import { initialStatisticAnalysisRangeSelectorState, StatisticAnalysisRangeSelectorState } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-range-selector/statistical-analysis-range-selector.model'
import { Vue, Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class StatisticalAnalysisRangeSelector extends Vue {
    @Prop({ default: false }) readonly rangeValue!: boolean
    @Emit()
    changeRange(): boolean {
        return this.state.value
    }

    state: StatisticAnalysisRangeSelectorState
    constructor() {
        super()
        this.state = initialStatisticAnalysisRangeSelectorState()
    }

    mounted() {
        this.state.value = this.rangeValue
    }

    onChangeRange(): void {
        this.changeRange()
    }
}
